import { PureComponent } from 'react';
import styled from 'styled-components';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UILink from 'UIComponents/link/UILink';
import OccurrenceLabel from 'ContentComponents/cmv2/occurrences/OccurrenceLabel';
import { getFieldFromKey, shouldOmitFieldFromBreadcrumbs } from 'ContentComponents/cmv2/utils';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { getDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "EditFormBreadcrumbs__Wrapper",
  componentId: "sc-1fe7sv0-0"
})(["border-bottom:", ";"], props => props.hideBottomBorder ? 'none' : `1px solid ${BATTLESHIP}`);
class EditFormBreadcrumbs extends PureComponent {
  renderBreadCrumbs() {
    const {
      fieldKey,
      fields,
      module,
      onKeyChange
    } = this.props;
    if (!fieldKey || !fields) {
      return null;
    }
    return fieldKey.reduce((acc, keyName, index) => {
      const _key = fieldKey.slice(0, index + 1);
      const _field = getFieldFromKey(fields, _key) || {};
      const isDisabled = !fieldKey || index === fieldKey.length - 1;
      if (shouldOmitFieldFromBreadcrumbs(_field)) return acc;
      if (_field && typeof keyName === 'number') {
        const _value = getDeepValue(module, _key);
        acc.push( /*#__PURE__*/_jsx(UILink, {
          disabled: isDisabled,
          onClick: () => onKeyChange(_key),
          children: /*#__PURE__*/_jsx(OccurrenceLabel, {
            asString: true,
            defaultLabel: _field.label || `${_value}`,
            field: _field,
            value: _value
          })
        }, _key.join('')));
      } else if (_field && !_field.occurrence) {
        acc.push( /*#__PURE__*/_jsx(UILink, {
          disabled: isDisabled,
          onClick: () => onKeyChange(_key),
          children: _field.label
        }, _key.join('')));
      }
      return acc;
    }, []);
  }
  render() {
    const {
      className,
      hideBottomBorder,
      rootBreadcrumbs
    } = this.props;
    return /*#__PURE__*/_jsx(Wrapper, {
      hideBottomBorder: hideBottomBorder,
      children: /*#__PURE__*/_jsxs(UIBreadcrumbs, {
        className: className,
        truncateToLevels: 2,
        singleBreadcrumbIsBackLink: false,
        children: [rootBreadcrumbs && rootBreadcrumbs, this.renderBreadCrumbs()]
      })
    });
  }
}
EditFormBreadcrumbs.defaultProps = {
  className: 'm-y-2 p-x-5'
};
export default EditFormBreadcrumbs;